import React from 'react';

const ButtonLoading = () => {
    return (
        <div className="h-10 animate-pulse bg-gray-200 rounded-full dark:bg-gray-700 w-[100px] mb-4"></div>
    );
};

export default ButtonLoading;